import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Protected from './Protected';
import { useAppSelector } from '../hooks/redux';
import { selectUser } from '../redux/user/userSlice';
import { listRoutes } from './listRoutes';

const Router = () => {
    const user = useAppSelector(selectUser);
    const isAdmin = user?.is_admin === 1;
    return (
        <>
            <BrowserRouter>
                <Routes>  
                    {listRoutes.map(({ path, Component, isCustomerSuccess }) => (
                        <Route
                            key={path}
                            path={`${process.env.REACT_APP_URL}${path}`}
                            element={
                                <Protected isAdmin={isAdmin} isAuth={Boolean(user.token)} isPageCustomerSuccess={isCustomerSuccess}>
                                    <Component />
                                </Protected>
                            }
                        />
                    ))}
                    <Route path={`${process.env.REACT_APP_URL}/*`} element={<>404</>} />
                </Routes>
            </BrowserRouter>
        </>
    );
};

export default Router;
